<template>
  <div class="__mainbacground">
    <div class="guest container-fluid d-flex py-5 justify-content-center">
      <div class="guest__container2">
        <div class="mb-4 text-center">
          <h3>Welcome to Andalin</h3>
          <p>Let's Active Your Account Here</p>
        </div>
        <b-form @submit.prevent="handleSubmit" novalidate>
          <b-form-group class="mb-3">
            <b-form-input type="text" name="email"
              :state="errors.first('email') && false"
              v-validate="'required'"
              placeholder="Enter your email"
              @input="errorMessage = ''"
              v-model="form.email"
            ></b-form-input>
            <p v-if="errors.has('email')" class="fontstyle__errormsg">
              {{ errors.first('email') }}
            </p>
          </b-form-group>
          <b-form-group class="mb-1" style="height: 70px;">
            <b-form-input :type="fieldType" name="passcode"
              :state="errors.first('passcode') && false"
              v-validate="'required'"
              placeholder="Passcode"
              @input="errorMessage = ''"
              v-model="form.passcode"
            ></b-form-input>
            <div class = "toggle-password" @click="toggleType">
              <img class="eyeabsolute1" src = "@/assets/image/eye_slash@2x.png" v-if="fieldType=='password'">
              <img class="eyeabsolute2" src = "@/assets/image/eye@2x.png" v-if="fieldType=='text'">
            </div>
            <p v-if="errors.has('passcode')" class="fontstyle__errormsg">
              {{ errors.first('passcode') }}
            </p>
             <p v-if="errorMessage" class="fontstyle__errormsg text-center mt-2">
              {{ errorMessage }}
            </p>
          </b-form-group>

          <div class="text-center">
            <button class="button__bluecorporite mt-3" v-if="isLoading"><b-spinner small variant="light"/></button>
            <button class="button__bluecorporite mt-3" v-else type="submit">Sign In</button>
          </div>
           <p class="textfooter text-center pb-3">By registering you confirm that you accept the <br>
            <a @click.prevent="terms()" href="#">Terms &amp; Conditions</a> and
            <a @click.prevent="policy()" href="#">Privacy Policy</a>
          </p>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GuestPersonalData',
  data: () => ({
    form: {
      email: '',
      passcode: '',
      shipmentId: ''
    },
    fieldType: 'password',
    errorMessage: ''
  }),
  computed: {
    ...mapGetters({
      isAuth: 'auth/isAuth',
      error: 'auth/error',
      isLoading: 'auth/isLoading',

      profile: 'auth/profile'
    })
  },
  mounted () {
    if (this.$route.query.mail) {
      this.form.email = this.$route.query.mail
    }
    if (this.$route.query.shipment) {
      this.form.shipmentId = this.$route.query.shipment
    }
  },
  methods: {
    handleSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('auth/POST_LOGIN', this.form)
        }
      })
    },
    toggleType () {
      if (this.fieldType === 'password') {
        this.fieldType = 'text'
      } else {
        this.fieldType = 'password'
      }
    },
    terms () {
      this.$eventHub.$emit('dialog-rule-terms')
    },
    policy () {
      this.$eventHub.$emit('dialog-rule-policy')
    }
  },
  watch: {
    error (data) {
      if (data) {
        this.errorMessage = data.message
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/guestSignIn/index.vue